import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
  output
} from '@angular/core';
import { IconModule } from '../../icon/icon.module';

export type IconButtonType =
  | 'primary'
  | 'primary-dark'
  | 'primary-darker'
  | 'secondary'
  | 'ghost';
export type IconButtonBorderType = 'circle' | 'rounded' | 'square';

@Component({
  selector: 'app-icon-button',
  standalone: true,
  imports: [IconModule],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent {
  type = input<IconButtonType>('primary');
  border = input<IconButtonBorderType>('rounded');
  icon = input.required<string>();
  disabled = input(false, { transform: booleanAttribute });
  iconBackground = input(false, { transform: booleanAttribute });

  clicked = output<MouseEvent>();
}
